import React from 'react';
import { motion } from 'framer-motion';
import { HiOutlineAcademicCap, HiOutlineBookOpen, HiOutlineClipboardList } from 'react-icons/hi';

const AdmissionHero = () => {
  return (
    <div className="relative w-full h-[40vh] sm:h-[45vh] md:h-[50vh] lg:h-[60vh] overflow-hidden">
      {/* Background Image with Parallax */}
      <motion.div
        initial={{ scale: 1.2 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.5 }}
        className="absolute inset-0"
      >
        <img
          src="/assets/coursebanner.png"
          alt="Admission Banner"
          className="w-full h-full object-cover"
        />
      </motion.div>

      {/* Light Gradient Overlay - Gray */}
      <div className="absolute inset-0 bg-gradient-to-r from-gray-200/80 via-gray-100/70 to-gray-200/80" />

      {/* Animated Background Elements - Light Gray */}
      <motion.div
        className="absolute top-20 left-10 text-gray-300/40 hidden lg:block"
        animate={{
          y: [0, -20, 0],
          rotate: [0, 10, -10, 0]
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      >
        <HiOutlineAcademicCap size={80} />
      </motion.div>

      <motion.div
        className="absolute bottom-20 right-10 text-gray-300/40 hidden lg:block"
        animate={{
          y: [0, 20, 0],
          rotate: [0, -10, 10, 0]
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      >
        <HiOutlineBookOpen size={70} />
      </motion.div>

      <motion.div
        className="absolute top-40 right-40 text-gray-300/40 hidden lg:block"
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.2, 0.3, 0.2]
        }}
        transition={{
          duration: 6,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      >
        <HiOutlineClipboardList size={60} />
      </motion.div>

      {/* Hero Content - Dark text for contrast */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 sm:px-6">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4 text-gray-800 drop-shadow-md"
        >
          Admission Details
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-sm sm:text-base md:text-lg lg:text-xl max-w-2xl px-4 leading-relaxed text-gray-700"
        >
          Your journey to excellence begins here. Explore our comprehensive admission process, requirements, and opportunities.
        </motion.p>

        {/* Breadcrumb - Dark text */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex items-center space-x-2 text-gray-600 text-sm sm:text-base"
        >
          <span>Home</span>
          <span className="text-gray-400">/</span>
          <span className="text-gray-800 font-semibold">Admission</span>
        </motion.div>

        {/* Scroll Indicator - Light Gray */}
        <motion.div
          className="absolute bottom-8 right-8 hidden sm:block"
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <div className="flex flex-col items-center">
            <span className="text-gray-500 text-xs mb-1">Scroll</span>
            <div className="w-5 h-8 border-2 border-gray-400 rounded-full flex justify-center">
              <div className="w-1 h-2 bg-gray-400 rounded-full mt-2" />
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default AdmissionHero;